import api from './api';

export const whatsappAPI = {
  getCaptureSettings: () => api.get('/whatsapp/capture/settings'),
  updateCaptureSettings: enabled => api.patch('/whatsapp/capture/settings', {enabled}),
  getCapture: id => api.get(`/whatsapp/conversations/${id}/capture`),
  getCaptureJob: id => api.get(`/whatsapp/capture/jobs/${id}`),
  getLeadCapture: id => api.get(`/whatsapp/capture/leads/${id}`),
  retryCapture: id => api.post(`/whatsapp/capture/jobs/${id}/retry`),
  reviewCapture: (id, payload) => api.post(`/whatsapp/capture/jobs/${id}/review`, payload),
  captureHistory: () => api.post('/whatsapp/capture/history'),
  getCaptureHistory: offset => api.get('/whatsapp/capture/history', {params:{offset}}),
  getDocuments: group => api.get(`/business-knowledge/documents/${group}`),
  getDocument: (group, key) => api.get(`/business-knowledge/documents/${group}/${key}`),
  saveDocument: (group, key, payload) => api.put(`/business-knowledge/documents/${group}/${key}`, payload),
  createAgentUpload: payload => api.post('/business-knowledge/uploads', payload),
  getBusinessInstructions: () => api.get('/business-knowledge/instructions'),
  saveBusinessInstructions: payload => api.patch('/business-knowledge/instructions', payload),
  getAgent: () => api.get('/whatsapp/agent'),
  updateAgent: payload => api.patch('/whatsapp/agent', payload),
  getAgentSources: () => api.get('/business-knowledge/sources'),
  getAgentVersion: id => api.get(`/business-knowledge/versions/${id}`),
  saveAgentSource: payload => api.post('/business-knowledge/sources', payload),
  previewCatalogueImport: (id, choices) => api.post(`/business-knowledge/versions/${id}/catalogue-preview`, {choices}),
  applyCatalogueImport: (id, choices, reviewToken) => api.post(`/business-knowledge/versions/${id}/apply-catalogue`, {choices,reviewToken}),
  publishAgentVersion: id => api.post(`/business-knowledge/versions/${id}/publish`),
  retryAgentVersion: id => api.post(`/business-knowledge/versions/${id}/retry`),
  deleteAgentSource: id => api.delete(`/business-knowledge/sources/${id}`),
  actOnHandover: (id, action) => api.post(`/whatsapp/conversations/${id}/agent/handover/${action}`),
  getConversationAgent: id => api.get(`/whatsapp/conversations/${id}/agent`),
  resetAgentContext: id => api.post(`/whatsapp/conversations/${id}/agent/reset-context`),
  regenerateAgent: id => api.post(`/whatsapp/conversations/${id}/agent/regenerate`),
  actOnAgent: (conversationId, id, action) => api.post(`/whatsapp/conversations/${conversationId}/agent/${id}/${action}`),
  getConfig: () => api.get('/whatsapp/config'),
  getConnection: () => api.get('/whatsapp/connection'),
  createSignupSession: () => api.post('/whatsapp/signup-session'),
  connect: (payload) => api.post('/whatsapp/connect', payload),
  disconnect: () => api.delete('/whatsapp/connection'),
  refreshConnection: () => api.post('/whatsapp/connection/refresh'),
  getTemplates: () => api.get('/whatsapp/templates'),
  getConversations: (params) => api.get('/whatsapp/conversations', { params }),
  getMessages: (conversationId, params) => api.get(`/whatsapp/conversations/${conversationId}/messages`, { params }),
  clearChat: id => api.delete(`/whatsapp/conversations/${id}/messages`),
  deleteChat: id => api.delete(`/whatsapp/conversations/${id}`),
  markRead: (conversationId, through) => api.post(`/whatsapp/conversations/${conversationId}/read`, { through }),
  updateConversation: (conversationId, payload) => api.patch(`/whatsapp/conversations/${conversationId}`, payload),
  linkLead: (conversationId, payload) => api.post(`/whatsapp/conversations/${conversationId}/link-lead`, payload),
  recordTemplateConsent: (conversationId, payload) => api.post(`/whatsapp/conversations/${conversationId}/template-consents`, payload),
  sendMessage: (conversationId, payload) => api.post(`/whatsapp/conversations/${conversationId}/messages`, payload),
  addNote: (conversationId, text) => api.post(`/whatsapp/conversations/${conversationId}/notes`, { text }),
  uploadMedia: (payload) => api.post('/whatsapp/media', payload),
  getMedia: (messageId) => api.get(`/whatsapp/messages/${messageId}/media`, { responseType: 'blob' }),
};

export default whatsappAPI;
